import { sortData } from '../../utils'
import { 
  SETTINGS_UPDATE_LEARNING_AREAS,
  SETTINGS_SELECTED_DATA_BY_AREA
} from '../actions/settingsActions'

const initState = {
  learningAreas: [],
  assessmentAreas: [],
  selectedAreas: {
    disciplines: [],
    modes: [],
    subjects: [],
    strands: [],
    subStrands: [],  
  },
}

const settingsReducer = (state = initState, action) => {
  const newState = { ...state }
  switch (action.type) {
    case SETTINGS_UPDATE_LEARNING_AREAS:
      newState.learningAreas = sortData( action.payload.learningAreas  || [], 'name', 'acs', 'string') 
    break   
    case SETTINGS_SELECTED_DATA_BY_AREA:
      if (action.payload.name === 'learningArea') {
        const currentData = newState.learningAreas.find((item) => Array.isArray(action.payload.value) ? action.payload.value[0] === item._id :  item._id === action.payload.value)
        if (currentData) {
          newState.selectedAreas.disciplines = Array.isArray(action.payload.value) && action.payload.value.length > 1 ? [] : currentData.disciplines
          newState.selectedAreas.modes =  Array.isArray(action.payload.value) && action.payload.value.length > 1 ? [] : currentData.modes

          newState.selectedAreas.strands = []
          newState.selectedAreas.subjects = []
          newState.selectedAreas.subStrands = []
        } else {
          newState.selectedAreas.disciplines = []
          newState.selectedAreas.modes = []

          newState.selectedAreas.strands = []
          newState.selectedAreas.subjects = []
          newState.selectedAreas.subStrands = []
        }
      } 

      if (action.payload.name === 'discipline') {
        const currentData = newState.selectedAreas.disciplines.find((item) => Array.isArray(action.payload.value) ? action.payload.value[0] === item._id :  item._id === action.payload.value)
          if (currentData) {
          newState.selectedAreas.strands = Array.isArray(action.payload.value) && action.payload.value.length > 1 ? [] : currentData.strands
          newState.selectedAreas.subjects = Array.isArray(action.payload.value) && action.payload.value.length > 1 ? [] : currentData.subjects
          newState.selectedAreas.subStrands = []
        } else {
          newState.selectedAreas.strands = []
          newState.selectedAreas.subjects = []
          newState.selectedAreas.subStrands = []
        }
      }

      if (action.payload.name === 'strand') {
        const currentData = newState.selectedAreas.strands.find((item) => Array.isArray(action.payload.value) ? action.payload.value[0] === item._id :  item._id === action.payload.value)
        if (currentData) {
          newState.selectedAreas.subStrands = Array.isArray(action.payload.value) && action.payload.value.length > 1 ? [] : currentData.subStrands
        } else {
          newState.selectedAreas.subStrands = []
        }
      }        
      break      
    default:
      break
  }
  return newState
}

export default settingsReducer
